/*
* Actions
*/

import { updateEntities } from 'redux-query';

// Association Search
export const SEARCH_CLIENT_DASHBOARD_KEYWORD = 'SEARCH_CLIENT_DASHBOARD_KEYWORD';

export const searchClientDashboardKeyword = keyword => {
  return {
    type: SEARCH_CLIENT_DASHBOARD_KEYWORD,
    keyword,
  };
};

// Association Inventory
export const ASSOCIATION_INVENTORY_GRID_SELECT = 'ASSOCIATION_INVENTORY_GRID_SELECT';

export const associationInventoryGridSelect = keys => {
  return {
    type: ASSOCIATION_INVENTORY_GRID_SELECT,
    keys,
  };
};

// Association Search
export const SEARCH_ASSOCIATIONS_KEYWORD = 'SEARCH_ASSOCIATIONS_KEYWORD';

export const searchAssociationsKeyword = keyword => {
  return {
    type: SEARCH_ASSOCIATIONS_KEYWORD,
    keyword,
  };
};

export const SEARCH_ASSOCIATIONS_ASSOCIATION_ID = 'SEARCH_ASSOCIATIONS_ASSOCIATION_ID';

export const searchAssociationsAssociationId = assocId => {
  return {
    type: SEARCH_ASSOCIATIONS_ASSOCIATION_ID,
    associationId: assocId,
  };
};

// Client Search
export const SEARCH_CLIENTS_KEYWORD = 'SEARCH_CLIENTS_KEYWORD';

export const searchClientsKeyword = keyword => {
  return {
    type: SEARCH_CLIENTS_KEYWORD,
    keyword,
  };
};

// User Search
export const SEARCH_USERS_KEYWORD = 'SEARCH_USERS_KEYWORD';

export const searchUsersKeyword = keyword => {
  return {
    type: SEARCH_USERS_KEYWORD,
    keyword,
  };
};

export const SEARCH_USERS_FILTER_MODE = 'SEARCH_USERS_FILTER_MODE';

export const searchUsersFilterMode = v => {
  return {
    type: SEARCH_USERS_FILTER_MODE,
    value: v,
  };
};

export const VIEW_ASSOCIATION_INVENTORY_SUBGROUP = 'VIEW_ASSOCIATION_INVENTORY_SUBGROUP';

export const viewAssociationInventorySubgroup = subgroup => {
  return {
    type: VIEW_ASSOCIATION_INVENTORY_SUBGROUP,
    subgroup,
  };
};

// Regional Component List
export const VIEW_REGIONAL_COMPONENT_LIST_SUBGROUP = 'VIEW_REGIONAL_COMPONENT_LIST_SUBGROUP';

export const viewRegionalComponentListSubgroup = subgroup => {
  return {
    type: VIEW_REGIONAL_COMPONENT_LIST_SUBGROUP,
    subgroup,
  };
};

export const SEARCH_COMPONENTS_REGIONAL_COMPONENT_LIST_ID = 'SEARCH_COMPONENTS_REGIONAL_COMPONENT_LIST_ID';

export const searchResearchComponentsFilterRegionalComponentListId = regionalComponentListId => {
  return {
    type: SEARCH_COMPONENTS_REGIONAL_COMPONENT_LIST_ID,
    regionalComponentListId,
  };
};

// Active Jobs Dashboard
export const ACTIVE_JOBS_FILTER_MANAGER = 'ACTIVE_JOBS_FILTER_MANAGER';

export const activeJobsFilterManager = username => {
  return {
    type: ACTIVE_JOBS_FILTER_MANAGER,
    username,
  };
};

export const ACTIVE_JOBS_FILTER_COORDINATOR = 'ACTIVE_JOBS_FILTER_COORDINATOR';

export const activeJobsFilterCoordinator = username => {
  return {
    type: ACTIVE_JOBS_FILTER_COORDINATOR,
    username,
  };
};

export const ACTIVE_JOBS_FILTER_STATUS = 'ACTIVE_JOBS_FILTER_STATUS';

export const activeJobsFilterStatusId = statusId => {
  return {
    type: ACTIVE_JOBS_FILTER_STATUS,
    statusId,
  };
};

export const ACTIVE_JOBS_FILTER_REGION = 'ACTIVE_JOBS_FILTER_REGION';

export const activeJobsFilterRegionId = regionId => {
  return {
    type: ACTIVE_JOBS_FILTER_REGION,
    regionId,
  };
};

// Prepared Bids Dashboard
export const PREPARED_BIDS_FILTER_MANAGER = 'PREPARED_BIDS_FILTER_MANAGER';

export const preparedBidsFilterManager = username => {
  return {
    type: PREPARED_BIDS_FILTER_MANAGER,
    username,
  };
};

export const PREPARED_BIDS_FILTER_STATUS = 'PREPARED_BIDS_FILTER_STATUS';

export const preparedBidsFilterStatusId = statusId => {
  return {
    type: PREPARED_BIDS_FILTER_STATUS,
    statusId,
  };
};

export const PREPARED_BIDS_FILTER_REGION = 'PREPARED_BIDS_FILTER_REGION';

export const preparedBidsFilterRegionId = regionId => {
  return {
    type: PREPARED_BIDS_FILTER_REGION,
    regionId,
  };
};

// Send Bids
export const SEND_BIDS_SELECTED_BIDS_OBJECT_IDS = 'SEND_BIDS_SELECTED_BIDS_OBJECT_IDS';

export const sendBidsSelectedBidsObjectIds = o => {
  return {
    type: SEND_BIDS_SELECTED_BIDS_OBJECT_IDS,
    o,
  };
};

export const SEND_BIDS_FILTER_MANAGER = 'SEND_BIDS_FILTER_MANAGER';

export const sendBidsFilterManager = username => {
  return {
    type: SEND_BIDS_FILTER_MANAGER,
    username,
  };
};

export const SEND_BIDS_FILTER_STATUS = 'SEND_BIDS_FILTER_STATUS';

export const sendBidsFilterStatusId = statusId => {
  return {
    type: SEND_BIDS_FILTER_STATUS,
    statusId,
  };
};

export const SEND_BIDS_FILTER_REGION = 'SEND_BIDS_FILTER_REGION';

export const sendBidsFilterRegionId = regionId => {
  return {
    type: SEND_BIDS_FILTER_REGION,
    regionId,
  };
};

// Associations Export Orders View
export const ASSOCIATION_EXPORT_ORDERS_FILTER_STATUS = 'ASSOCIATION_EXPORT_ORDERS_FILTER_STATUS';

export const associationExportOrdersFilterStatusId = statusId => {
  return {
    type: ASSOCIATION_EXPORT_ORDERS_FILTER_STATUS,
    statusId,
  };
};

export const ASSOCIATION_EXPORT_ORDERS_FILTER_REGION = 'ASSOCIATION_EXPORT_ORDERS_FILTER_REGION';

export const associationExportOrdersFilterRegionId = regionId => {
  return {
    type: ASSOCIATION_EXPORT_ORDERS_FILTER_REGION,
    regionId,
  };
};

export const ASSOCIATION_EXPORT_ORDERS_FROM_BID_DATE = 'ASSOCIATION_EXPORT_ORDERS_FROM_BID_DATE';

export const associationExportOrdersFilterFromBidDate = v => {
  return {
    type: ASSOCIATION_EXPORT_ORDERS_FROM_BID_DATE,
    value: v,
  };
};

export const ASSOCIATION_EXPORT_ORDERS_TO_BID_DATE = 'ASSOCIATION_EXPORT_ORDERS_TO_BID_DATE';

export const associationExportOrdersFilterToBidDate = v => {
  return {
    type: ASSOCIATION_EXPORT_ORDERS_TO_BID_DATE,
    value: v,
  };
};

// SEARCH ORDERS
export const SEARCH_ORDERS_ASSOCIATION = 'SEARCH_ORDERS_ASSOCIATION';

export const searchOrdersFilterAssociationId = associationId => {
  return {
    type: SEARCH_ORDERS_ASSOCIATION,
    associationId,
  };
};

export const SEARCH_ORDERS_CLIENT = 'SEARCH_ORDERS_CLIENT';

export const searchOrdersFilterClientId = clientId => {
  return {
    type: SEARCH_ORDERS_CLIENT,
    clientId,
  };
};

export const SEARCH_ORDERS_STATUS = 'SEARCH_ORDERS_STATUS';

export const searchOrdersFilterStatusId = statusId => {
  return {
    type: SEARCH_ORDERS_STATUS,
    statusId,
  };
};

export const SEARCH_CLIENT_CONTACTS_REGION = 'SEARCH_CLIENT_CONTACTS_REGION';

export const searchClientContactsFilterRegionId = regionId => {
  return {
    type: SEARCH_CLIENT_CONTACTS_REGION,
    regionId,
  };
};

export const SEARCH_CLIENT_CONTACTS_CLIENTTYPE = 'SEARCH_CLIENT_CONTACTS_CLIENTTYPE';

export const searchClientContactsFilterClientTypeId = clientTypeId => {
  return {
    type: SEARCH_CLIENT_CONTACTS_CLIENTTYPE,
    clientTypeId,
  };
};

export const SEARCH_COORDINATOR_JOBS_REGION = 'SEARCH_COORDINATOR_JOBS_REGION';

export const searchCoordinatorJobsFilterRegionId = regionId => {
  return {
    type: SEARCH_COORDINATOR_JOBS_REGION,
    regionId,
  };
};

export const SEARCH_COORDINATOR_JOBS_COORDINATOR = 'SEARCH_COORDINATOR_JOBS_COORDINATOR';

export const searchCoordinatorJobsFilterCoordinator = username => {
  return {
    type: SEARCH_COORDINATOR_JOBS_COORDINATOR,
    username,
  };
};

export const SEARCH_COORDINATOR_JOBS_FROM_DATE = 'SEARCH_COORDINATOR_JOBS_FROM_DATE';

export const searchCoordinatorJobsFilterFromDate = fromDate => {
  return {
    type: SEARCH_COORDINATOR_JOBS_FROM_DATE,
    fromDate,
  };
};

export const SEARCH_COORDINATOR_JOBS_TO_DATE = 'SEARCH_COORDINATOR_JOBS_TO_DATE';

export const searchCoordinatorJobsFilterToDate = toDate => {
  return {
    type: SEARCH_COORDINATOR_JOBS_TO_DATE,
    toDate,
  };
};

export const SEARCH_COORDINATOR_JOBS_PAID = 'SEARCH_COORDINATOR_JOBS_PAID';

export const searchCoordinatorJobsFilterPaid = paid => {
  return {
    type: SEARCH_COORDINATOR_JOBS_PAID,
    paid,
  };
};

export const SEARCH_COORDINATOR_JOBS_STATUS = 'SEARCH_COORDINATOR_JOBS_STATUS';

export const searchCoordinatorJobsFilterStatusId = statusId => {
  return {
    type: SEARCH_COORDINATOR_JOBS_STATUS,
    statusId,
  };
};

export const SEARCH_COMPONENTS_FROM_DATE = 'SEARCH_COMPONENTS_FROM_DATE';

export const searchResearchComponentsFilterFromDate = fromDate => {
  return {
    type: SEARCH_COMPONENTS_FROM_DATE,
    fromDate,
  };
};

export const SEARCH_COMPONENTS_TO_DATE = 'SEARCH_COMPONENTS_TO_DATE';

export const searchResearchComponentsFilterToDate = toDate => {
  return {
    type: SEARCH_COMPONENTS_TO_DATE,
    toDate,
  };
};

export const SEARCH_COMPONENTS_ASSOCIATION_ID = 'SEARCH_COMPONENTS_ASSOCIATION_ID';

export const searchResearchComponentsFilterAssociationId = assocId => {
  return {
    type: SEARCH_COMPONENTS_ASSOCIATION_ID,
    assocId,
  };
};

export const SEARCH_COMPONENTS_COMPONENT_ID = 'SEARCH_COMPONENTS_COMPONENT_ID';

export const searchResearchComponentsFilterComponentId = componentId => {
  return {
    type: SEARCH_COMPONENTS_COMPONENT_ID,
    componentId,
  };
};

export const SEARCH_COMPONENTS_SEARCH_TERM = 'SEARCH_COMPONENTS_SEARCH_TERM';

export const searchResearchComponentsFilterSearchTerm = searchTerm => {
  return {
    type: SEARCH_COMPONENTS_SEARCH_TERM,
    searchTerm,
  };
};

export const SEARCH_COMPONENTS_DATE_RANGE = 'SEARCH_COMPONENTS_DATE_RANGE';

export const searchResearchComponentsFilterDateRange = dateRange => {
  return {
    type: SEARCH_COMPONENTS_DATE_RANGE,
    dateRange,
  };
};

export const searchResearchComponentsClear = () => updateEntities({
      searchResearchComponentsResults: (v) => undefined,
      searchResearchComponentsAssociations: (v) => undefined,
  });

/* RESEARCH BIDS */

export const SEARCH_RESEARCH_BIDS_ALL = 'SEARCH_RESEARCH_BIDS_ALL';

export const searchResearchBidsAll = (state) => {
  return {
    type: SEARCH_RESEARCH_BIDS_ALL,
    state: state,
  };
};

export const SEARCH_RESEARCH_BIDS_UNITS_RANGE = 'SEARCH_RESEARCH_BIDS_UNITS_RANGE';

export const searchResearchBidsFilterUnitsRange = (low, high) => {
  return {
    type: SEARCH_RESEARCH_BIDS_UNITS_RANGE,
    low: low,
    high: high,
  };
};

export const SEARCH_RESEARCH_BIDS_BUILDINGS_RANGE = 'SEARCH_RESEARCH_BIDS_BUILDINGS_RANGE';

export const searchResearchBidsFilterBuildingsRange = (low, high) => {
  return {
    type: SEARCH_RESEARCH_BIDS_BUILDINGS_RANGE,
    low: low,
    high: high,
  };
};

export const SEARCH_RESEARCH_BIDS_STREETS_MULTI = 'SEARCH_RESEARCH_BIDS_STREETS_MULTI';

export const searchResearchBidsFilterStreetsMulti = v => {
  return {
    type: SEARCH_RESEARCH_BIDS_STREETS_MULTI,
    value: v,
  };
};

export const SEARCH_RESEARCH_BIDS_ASSOCIATION_TYPES_MULTI = 'SEARCH_RESEARCH_BIDS_ASSOCIATION_TYPES_MULTI';

export const searchResearchBidsFilterAssociationTypesMulti = v => {
  return {
    type: SEARCH_RESEARCH_BIDS_ASSOCIATION_TYPES_MULTI,
    value: v,
  };
};

export const SEARCH_RESEARCH_BIDS_STATUSES_MULTI = 'SEARCH_RESEARCH_BIDS_STATUSES_MULTI';

export const searchResearchBidsFilterStatusesMulti = v => {
  return {
    type: SEARCH_RESEARCH_BIDS_STATUSES_MULTI,
    value: v,
  };
};

export const SEARCH_RESEARCH_BIDS_SPAS_MULTI = 'SEARCH_RESEARCH_BIDS_SPAS_MULTI';

export const searchResearchBidsFilterSpasMulti = v => {
  return {
    type: SEARCH_RESEARCH_BIDS_SPAS_MULTI,
    value: v,
  };
};

export const SEARCH_RESEARCH_BIDS_POOLS_MULTI = 'SEARCH_RESEARCH_BIDS_POOLS_MULTI';

export const searchResearchBidsFilterPoolsMulti = v => {
  return {
    type: SEARCH_RESEARCH_BIDS_POOLS_MULTI,
    value: v,
  };
};

export const SEARCH_RESEARCH_BIDS_CLIENTS_MULTI = 'SEARCH_RESEARCH_BIDS_CLIENTS_MULTI';

export const searchResearchBidsFilterClientsMulti = v => {
  return {
    type: SEARCH_RESEARCH_BIDS_CLIENTS_MULTI,
    value: v,
  };
};

export const SEARCH_RESEARCH_BIDS_REGIONS_MULTI = 'SEARCH_RESEARCH_BIDS_REGIONS_MULTI';

export const searchResearchBidsFilterRegionsMulti = v => {
  return {
    type: SEARCH_RESEARCH_BIDS_REGIONS_MULTI,
    value: v,
  };
};

export const SEARCH_RESEARCH_BIDS_FROM_BID_DATE = 'SEARCH_RESEARCH_BIDS_FROM_BID_DATE';

export const searchResearchBidsFilterFromBidDate = v => {
  return {
    type: SEARCH_RESEARCH_BIDS_FROM_BID_DATE,
    value: v,
  };
};

export const SEARCH_RESEARCH_BIDS_TO_BID_DATE = 'SEARCH_RESEARCH_BIDS_TO_BID_DATE';

export const searchResearchBidsFilterToBidDate = v => {
  return {
    type: SEARCH_RESEARCH_BIDS_TO_BID_DATE,
    value: v,
  };
};

export const SEARCH_RESEARCH_BIDS_DATE_RANGE = 'SEARCH_RESEARCH_BIDS_DATE_RANGE';

export const searchResearchBidsDateRange = dateRange => {
  return {
    type: SEARCH_RESEARCH_BIDS_DATE_RANGE,
    dateRange,
  };
};

export const SEARCH_RESEARCH_BIDS_FROM_COMPLETION_DATE = 'SEARCH_RESEARCH_BIDS_FROM_COMPLETION_DATE';

export const searchResearchBidsFilterFromCompletionDate = v => {
  return {
    type: SEARCH_RESEARCH_BIDS_FROM_COMPLETION_DATE,
    value: v,
  };
};

export const SEARCH_RESEARCH_BIDS_TO_COMPLETION_DATE = 'SEARCH_RESEARCH_BIDS_TO_COMPLETION_DATE';

export const searchResearchBidsFilterToCompletionDate = v => {
  return {
    type: SEARCH_RESEARCH_BIDS_TO_COMPLETION_DATE,
    value: v,
  };
};

/* OUTSTANDING BIDS */
export const SEARCH_OUTSTANDING_BIDS_STATUS = 'SEARCH_OUTSTANDING_BIDS_STATUS';

export const searchOutstandingBidsFilterStatus = v => {
  return {
    type: SEARCH_OUTSTANDING_BIDS_STATUS,
    value: v,
  };
};

export const SEARCH_OUTSTANDING_BIDS_CLIENT = 'SEARCH_OUTSTANDING_BIDS_CLIENT';

export const searchOutstandingBidsFilterClient = v => {
  return {
    type: SEARCH_OUTSTANDING_BIDS_CLIENT,
    value: v,
  };
};

export const SEARCH_OUTSTANDING_BIDS_REGION = 'SEARCH_OUTSTANDING_BIDS_REGION';

export const searchOutstandingBidsFilterRegion = v => {
  return {
    type: SEARCH_OUTSTANDING_BIDS_REGION,
    value: v,
  };
};

export const SEARCH_OUTSTANDING_BIDS_FROM_BID_DATE = 'SEARCH_OUTSTANDING_BIDS_FROM_BID_DATE';

export const searchOutstandingBidsFilterFromBidDate = v => {
  return {
    type: SEARCH_OUTSTANDING_BIDS_FROM_BID_DATE,
    value: v,
  };
};

export const SEARCH_OUTSTANDING_BIDS_TO_BID_DATE = 'SEARCH_OUTSTANDING_BIDS_TO_BID_DATE';

export const searchOutstandingBidsFilterToBidDate = v => {
  return {
    type: SEARCH_OUTSTANDING_BIDS_TO_BID_DATE,
    value: v,
  };
};

export const SEARCH_OUTSTANDING_BIDS_FROM_FOLLOW_UP_DATE = 'SEARCH_OUTSTANDING_BIDS_FROM_FOLLOW_UP_DATE';

export const searchOutstandingBidsFilterFromFollowUpDate = v => {
  return {
    type: SEARCH_OUTSTANDING_BIDS_FROM_FOLLOW_UP_DATE,
    value: v,
  };
};

export const SEARCH_OUTSTANDING_BIDS_TO_FOLLOW_UP_DATE = 'SEARCH_OUTSTANDING_BIDS_TO_FOLLOW_UP_DATE';

export const searchOutstandingBidsFilterToFollowUpDate = v => {
  return {
    type: SEARCH_OUTSTANDING_BIDS_TO_FOLLOW_UP_DATE,
    value: v,
  };
};

export const SEARCH_OUTSTANDING_BIDS_UNSOLICITED_BID = 'SEARCH_OUTSTANDING_BIDS_UNSOLICITED_BID';

export const searchOutstandingBidsFilterUnsolicitedBid = v => {
  return {
    type: SEARCH_OUTSTANDING_BIDS_UNSOLICITED_BID,
    value: v,
  };
};

export const SEARCH_OUTSTANDING_BIDS_SELECTED_ORDER_IDS = 'SEARCH_OUTSTANDING_BIDS_SELECTED_ORDER_IDS';

export const searchOutstandingBidsFilterSelectedOrderIds = v => {
  return {
    type: SEARCH_OUTSTANDING_BIDS_SELECTED_ORDER_IDS,
    value: v,
  };
};

/* REMINDER BIDS */
export const SEARCH_REMINDER_BIDS_STATUS = 'SEARCH_REMINDER_BIDS_STATUS';

export const searchReminderBidsFilterStatus = v => {
  return {
    type: SEARCH_REMINDER_BIDS_STATUS,
    value: v,
  };
};

export const SEARCH_REMINDER_BIDS_CLIENT = 'SEARCH_REMINDER_BIDS_CLIENT';

export const searchReminderBidsFilterClient = v => {
  return {
    type: SEARCH_REMINDER_BIDS_CLIENT,
    value: v,
  };
};

export const SEARCH_REMINDER_BIDS_REGION = 'SEARCH_REMINDER_BIDS_REGION';

export const searchReminderBidsFilterRegion = v => {
  return {
    type: SEARCH_REMINDER_BIDS_REGION,
    value: v,
  };
};

export const SEARCH_REMINDER_BIDS_FROM_BID_DATE = 'SEARCH_REMINDER_BIDS_FROM_BID_DATE';

export const searchReminderBidsFilterFromBidDate = v => {
  return {
    type: SEARCH_REMINDER_BIDS_FROM_BID_DATE,
    value: v,
  };
};

export const SEARCH_REMINDER_BIDS_TO_BID_DATE = 'SEARCH_REMINDER_BIDS_TO_BID_DATE';

export const searchReminderBidsFilterToBidDate = v => {
  return {
    type: SEARCH_REMINDER_BIDS_TO_BID_DATE,
    value: v,
  };
};

export const SEARCH_REMINDER_BIDS_FROM_FOLLOW_UP_DATE = 'SEARCH_REMINDER_BIDS_FROM_FOLLOW_UP_DATE';

export const searchReminderBidsFilterFromFollowUpDate = v => {
  return {
    type: SEARCH_REMINDER_BIDS_FROM_FOLLOW_UP_DATE,
    value: v,
  };
};

export const SEARCH_REMINDER_BIDS_TO_FOLLOW_UP_DATE = 'SEARCH_REMINDER_BIDS_TO_FOLLOW_UP_DATE';

export const searchReminderBidsFilterToFollowUpDate = v => {
  return {
    type: SEARCH_REMINDER_BIDS_TO_FOLLOW_UP_DATE,
    value: v,
  };
};

export const SEARCH_REMINDER_BIDS_UNSOLICITED_BID = 'SEARCH_REMINDER_BIDS_UNSOLICITED_BID';

export const searchReminderBidsFilterUnsolicitedBid = v => {
  return {
    type: SEARCH_REMINDER_BIDS_UNSOLICITED_BID,
    value: v,
  };
};

export const SEARCH_REMINDER_BIDS_SERVICE_LEVEL = 'SEARCH_REMINDER_BIDS_SERVICE_LEVEL';

export const searchReminderBidsFilterServiceLevel = v => {
  return {
    type: SEARCH_REMINDER_BIDS_SERVICE_LEVEL,
    value: v,
  };
};

export const SEARCH_REMINDER_BIDS_SELECTED_ORDER_IDS = 'SEARCH_REMINDER_BIDS_SELECTED_ORDER_IDS';

export const searchReminderBidsFilterSelectedOrderIds = v => {
  return {
    type: SEARCH_REMINDER_BIDS_SELECTED_ORDER_IDS,
    value: v,
  };
};

export const SEARCH_REMINDER_BIDS_FROM_COMPLETION_DATE = 'SEARCH_REMINDER_BIDS_FROM_COMPLETION_DATE';

export const searchReminderBidsFilterFromCompletionDate = v => {
  return {
    type: SEARCH_REMINDER_BIDS_FROM_COMPLETION_DATE,
    value: v,
  };
};

export const SEARCH_REMINDER_BIDS_TO_COMPLETION_DATE = 'SEARCH_REMINDER_BIDS_TO_COMPLETION_DATE';

export const searchReminderBidsFilterToCompletionDate = v => {
  return {
    type: SEARCH_REMINDER_BIDS_TO_COMPLETION_DATE,
    value: v,
  };
};

export const SEARCH_REMINDER_BIDS_FROM_REMINDER_DATE = 'SEARCH_REMINDER_BIDS_FROM_REMINDER_DATE';

export const searchReminderBidsFilterFromReminderDate = v => {
  return {
    type: SEARCH_REMINDER_BIDS_FROM_REMINDER_DATE,
    value: v,
  };
};

export const SEARCH_REMINDER_BIDS_TO_REMINDER_DATE = 'SEARCH_REMINDER_BIDS_TO_REMINDER_DATE';

export const searchReminderBidsFilterToReminderDate = v => {
  return {
    type: SEARCH_REMINDER_BIDS_TO_REMINDER_DATE,
    value: v,
  };
};

export const SEARCH_REMINDER_BIDS_FROM_SENT_DATE = 'SEARCH_REMINDER_BIDS_FROM_SENT_DATE';

export const searchReminderBidsFilterFromSentDate = v => {
  return {
    type: SEARCH_REMINDER_BIDS_FROM_SENT_DATE,
    value: v,
  };
};

export const SEARCH_REMINDER_BIDS_TO_SENT_DATE = 'SEARCH_REMINDER_BIDS_TO_SENT_DATE';

export const searchReminderBidsFilterToSentDate = v => {
  return {
    type: SEARCH_REMINDER_BIDS_TO_SENT_DATE,
    value: v,
  };
};

/* WON JOBS */

export const SEARCH_WON_JOBS_STATUS = 'SEARCH_WON_JOBS_STATUS';

export const searchWonJobsFilterStatus = v => {
  return {
    type: SEARCH_WON_JOBS_STATUS,
    value: v,
  };
};

export const SEARCH_WON_JOBS_REGION = 'SEARCH_WON_JOBS_REGION';

export const searchWonJobsFilterRegion = v => {
  return {
    type: SEARCH_WON_JOBS_REGION,
    value: v,
  };
};

export const SEARCH_WON_JOBS_FROM_WON_DATE = 'SEARCH_WON_JOBS_FROM_WON_DATE';

export const searchWonJobsFilterFromWonDate = v => {
  return {
    type: SEARCH_WON_JOBS_FROM_WON_DATE,
    value: v,
  };
};

export const SEARCH_WON_JOBS_TO_WON_DATE = 'SEARCH_WON_JOBS_TO_WON_DATE';

export const searchWonJobsFilterToWonDate = v => {
  return {
    type: SEARCH_WON_JOBS_TO_WON_DATE,
    value: v,
  };
};

export const SEARCH_WON_JOBS_ENTERED_QUICKBOOKS = 'SEARCH_WON_JOBS_ENTERED_QUICKBOOKS';

export const searchWonJobsFilterEnteredQuickbooks = v => {
  return {
    type: SEARCH_WON_JOBS_ENTERED_QUICKBOOKS,
    value: v,
  };
};

export const SEARCH_WON_JOBS_INVOICE_SENT_QUICKBOOKS = 'SEARCH_WON_JOBS_INVOICE_SENT_QUICKBOOKS';

export const searchWonJobsFilterInvoiceSentQuickbooks = v => {
  return {
    type: SEARCH_WON_JOBS_INVOICE_SENT_QUICKBOOKS,
    value: v,
  };
};

export const SEARCH_WON_JOBS_FILTER_MODE = 'SEARCH_WON_JOBS_FILTER_MODE';

export const searchWonJobsFilterMode = v => {
  return {
    type: SEARCH_WON_JOBS_FILTER_MODE,
    value: v,
  };
};

/* NEW RESEARCH BIDS */

export const SEARCH_NEW_RESEARCH_BIDS_BID_DATE_RANGE = 'SEARCH_NEW_RESEARCH_BIDS_BID_DATE_RANGE';

export const searchNewResearchBidsFilterBidDateRange = (value) => {
  return {
    type: SEARCH_NEW_RESEARCH_BIDS_BID_DATE_RANGE,
    value
  };
};

export const SEARCH_NEW_RESEARCH_BIDS_FROM_BID_DATE = 'SEARCH_NEW_RESEARCH_BIDS_FROM_BID_DATE';

export const searchNewResearchBidsFilterFromBidDate = (value) => {
  return {
    type: SEARCH_NEW_RESEARCH_BIDS_FROM_BID_DATE,
    value
  };
};

export const SEARCH_NEW_RESEARCH_BIDS_TO_BID_DATE = 'SEARCH_NEW_RESEARCH_BIDS_TO_BID_DATE';

export const searchNewResearchBidsFilterToBidDate = (value) => {
  return {
    type: SEARCH_NEW_RESEARCH_BIDS_TO_BID_DATE,
    value
  };
};

export const SEARCH_NEW_RESEARCH_BIDS_COMPLETION_DATE_RANGE = 'SEARCH_NEW_RESEARCH_BIDS_COMPLETION_DATE_RANGE';

export const searchNewResearchBidsFilterCompletionDateRange = (value) => {
  return {
    type: SEARCH_NEW_RESEARCH_BIDS_COMPLETION_DATE_RANGE,
    value
  };
};

export const SEARCH_NEW_RESEARCH_BIDS_FROM_COMPLETION_DATE = 'SEARCH_NEW_RESEARCH_BIDS_FROM_COMPLETION_DATE';

export const searchNewResearchBidsFilterFromCompletionDate = (value) => {
  return {
    type: SEARCH_NEW_RESEARCH_BIDS_FROM_COMPLETION_DATE,
    value
  };
};

export const SEARCH_NEW_RESEARCH_BIDS_TO_COMPLETION_DATE = 'SEARCH_NEW_RESEARCH_BIDS_TO_COMPLETION_DATE';

export const searchNewResearchBidsFilterToCompletionDate = (value) => {
  return {
    type: SEARCH_NEW_RESEARCH_BIDS_TO_COMPLETION_DATE,
    value
  };
};

// Association Detail/Edit/View
export const TOGGLE_EDITMODE_FOR_ASSOCIATION = 'TOGGLE_EDITMODE_FOR_ASSOCIATION';

export const toggleEditModeForAssociation = (value) => {
  return {
    type: TOGGLE_EDITMODE_FOR_ASSOCIATION,
    value: value
  };
};

export const ASSOCIATION_EDIT_FORM_UPDATE = 'ASSOCIATION_EDIT_FORM_UPDATE';

export const associationEditFormUpdate = (data, errors) => {
  return {
    type: ASSOCIATION_EDIT_FORM_UPDATE,
    data,
    errors
  };
};

// Add Bid View
export const ADD_BID_REDIRECT = 'ADD_BID_REDIRECT';

export const addBidRedirect = (value) => {
  return {
    type: ADD_BID_REDIRECT,
    value,
  };
};



// WEBPACK FOOTER //
// ./src/actions/index.tsx